<!-- results-table.component.html -->
<h1 mat-dialog-title>
    {{ LOCAL_DATA.pep.fuente }}
</h1>
<div mat-dialog-content>
    <table class="table table-striped">
        <thead></thead>
        <tbody>
            <tr>
                <td>Nombre completo:</td>
                <td>{{ LOCAL_DATA.pep.nombreCompleto }}</td>
            </tr>
            <tr>
                <td>Estado:</td>
                <td>{{ LOCAL_DATA.estado}}  <a (click)="openDialogEditarEstadoLink()" style="cursor: pointer"><mat-icon matTooltip="Modificar estado">edit</mat-icon></a> </td>
            </tr>
            <tr>
                <td>Tipo:</td>
                <td>{{ LOCAL_DATA.pep.tipo }}</td>
            </tr>
            <tr *ngIf="LOCAL_DATA.pep.fechaDeNacimiento">
                <td>Fecha de nacimiento:</td>
                <td>{{ LOCAL_DATA.pep.fechaDeNacimiento }}</td>
            </tr>
            <tr *ngIf="LOCAL_DATA.pep.pais">
                <td>Nacionalidad:</td>
                <td>{{ LOCAL_DATA.pep.pais }}</td>
            </tr>
            <tr *ngIf="LOCAL_DATA.pep.cargo">
                <td>Cargo:</td>
                <td>{{ LOCAL_DATA.pep.cargo }}</td>
            </tr>
            <tr *ngIf="LOCAL_DATA.pep.organizacion">
                <td>Organización:</td>
                <td>{{ LOCAL_DATA.pep.organizacion }}</td>
            </tr>
            <tr *ngIf="LOCAL_DATA.pep.detalle">
                <td>Detalle:</td>
                <td>{{ LOCAL_DATA.pep.detalle }}</td>
            </tr>
            <tr *ngIf="LOCAL_DATA.pep.informacionAdicional">
                <td>Información adicional:</td>
                <td>{{ LOCAL_DATA.pep.informacionAdicional }}</td>
            </tr>
            <tr *ngIf="LOCAL_DATA.pep.imagen">
                <td>Imagen:</td>
                <td><img [src]="LOCAL_DATA.pep.imagen" /></td>
            </tr>
            <tr
                *ngIf="
                    LOCAL_DATA.pep.documentosDeIdentidad &&
                    LOCAL_DATA.pep.documentosDeIdentidad.length > 0
                "
            >
                <td>Documentos de identidad:</td>
                <td>
                    <table class="table table-striped" [fxFlex]="100">
                        <thead>
                            <tr>
                                <th>País</th>
                                <th>Tipo</th>
                                <th>Numero</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="
                                    let documento of LOCAL_DATA.pep
                                        .documentosDeIdentidad
                                "
                            >
                                <td>{{ documento.pais }}</td>
                                <td>{{ documento.tipo }}</td>
                                <td>{{ documento.numero }}</td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>Link:</td>
                <td>
                    <a [href]="LOCAL_DATA.pep.urlArchivo" target="_blank"
                        >Link</a
                    >
                </td>
            </tr>
        </tbody>
    </table>

    <div mat-dialog-actions>
        <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
            {{ "Cerrar" | translate }}
        </button>
    </div>
</div>
